const _excluded = ["federatedComponentsCtx"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import Head from "next/head";
import { composeDataMethods } from "@lululemon/mwa-utils";
import { getOrCreateFederatedComponentCtx, federatedComponentsContext } from "./federated-component";
const withFederationPrerender = remotes => Component => {
  const WithFederationPrerender = _ref => {
    let {
        federatedComponentsCtx
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const ctx = getOrCreateFederatedComponentCtx({
      remotes
    }, federatedComponentsCtx);
    const uniqueChunks = [...new Set(ctx.chunks)];
    return /*#__PURE__*/React.createElement(federatedComponentsContext.Provider, {
      value: ctx
    }, /*#__PURE__*/React.createElement(Head, null, uniqueChunks.map(chunk => chunk.endsWith(".css") ? /*#__PURE__*/React.createElement("link", {
      key: chunk,
      rel: "stylesheet",
      href: chunk
    }) : null)), /*#__PURE__*/React.createElement(Component, props), uniqueChunks.map(chunk => chunk.endsWith(".js") ? /*#__PURE__*/React.createElement("script", {
      "data-bull": "t",
      key: chunk,
      async: true,
      src: chunk
    }) : null));
  };
  return composeDataMethods(Component, {
    async getInitialProps(appContext) {
      var _next_data$props;
      const next_data = typeof __NEXT_DATA__ !== "undefined" ? __NEXT_DATA__ : null;
      const federatedComponentsCtx = await getOrCreateFederatedComponentCtx({
        remotes
      }, typeof window !== "undefined" ? next_data === null || next_data === void 0 ? void 0 : (_next_data$props = next_data.props) === null || _next_data$props === void 0 ? void 0 : _next_data$props.federatedComponentsCtx : null);
      return {
        federatedComponentsCtx
      };
    },
    async postProcessInitialProps(initialProps) {
      if (initialProps.federatedComponentsCtx) {
        await Promise.all(Array.from(initialProps.federatedComponentsCtx.promises.values()));
      }
      return initialProps;
    }
  })(WithFederationPrerender);
};
export default withFederationPrerender;